import styled from '@emotion/styled';

const SectionNav = styled('nav')`
  height: 48px;
  background: white;
  border-bottom: 1px solid ${({ theme }) => theme.gray.medium};
  display: flex;
  justify-content: space-between;
  overflow-x: scroll;
  overflow-y: hidden;

  &::-webkit-scrollbar {
    height: 0px;
  }
`;

export default SectionNav;
